import { render, staticRenderFns } from "./_userNotesModal.vue?vue&type=template&id=6fba278b"
import script from "./_userNotesModal.vue?vue&type=script&lang=js"
export * from "./_userNotesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports